import { useMemo } from "react";
import { useSelector } from "react-redux";

export const useReduxHook = () => {
  const user = useSelector((state) => state.user);
  const isDevUser = useMemo(
    () =>
      user?.emailAddress === "joliva@cliffcomortgage.com" ||
      user?.emailAddress === "dev1@cliffcomortgage.com" ||
      user?.emailAddress === "cwolpert@cliffcomortgage.com",
    [user]
  );
  return {
    isDevUser,
  };
};
